export default __webpack_public_path__ + "static/media/header-logo.daedd661.svg";